import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
import { Section } from "./_section";
/**
 * StatCardBlock — data-driven single-statistic band.
 *
 * Net-new, serializable contract (see @diality/contracts StatCardData).
 * Rendered identically by the CMS canvas and the public site; only image
 * resolution differs, via BlockRenderProvider. Renders as a centered, contained
 * band that auto-alternates its tone (BlockBandContext) like every other block;
 * its large primary numeral carries the band identity on any background.
 */
const CONTAINER = "mx-auto max-w-7xl px-4 @min-[640px]:px-6 @min-[1024px]:px-8";
export function StatCardBlock({ data }) {
    const { value, label, caption, icon } = data;
    return (_jsx(Section, { children: _jsx("div", { className: CONTAINER, children: _jsxs("div", { className: "mx-auto flex max-w-3xl flex-col items-center gap-3 text-center", children: [icon && (_jsx("div", { className: "inline-flex size-12 items-center justify-center rounded-xl bg-primary/10 text-primary", children: _jsx(MediaSlotView, { image: icon, ratio: "1 / 1", label: "Icon", className: "size-8", emptyRender: null }) })), _jsx("div", { className: "text-5xl font-bold tracking-tighter text-primary @min-[640px]:text-6xl", children: value }), _jsx("div", { className: "text-sm font-bold uppercase tracking-wide text-muted-foreground", children: label }), caption && _jsx("p", { className: "max-w-prose text-base text-muted-foreground", children: caption })] }) }) }));
}
export function statCardFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    return {
        value: s.value || "",
        label: s.label || "",
        caption: s.caption || undefined,
        // One declared target, so this resolves to a single framing every screen
        // sees — the same rendering as before multi-target slots existed.
        icon: resolveSlotMedia(block, "icon", resolve),
    };
}
export const statCardBlockEntry = {
    Component: StatCardBlock,
    fromBlock: statCardFromBlock,
};
//# sourceMappingURL=stat-card.js.map